import { sendAnalytics } from 'shared/utils/analytics';

export const trackOfferPreviewShow = () => sendAnalytics({ action: 'card', label: 'history_offers' });
